import React from "react";
import { withRouter } from "react-router-dom";

/**
 * Resets the scroll position on every route change.
 *
 * The app renders inside `.shipment-background`, which is the element that
 * actually scrolls (`height: 100dvh; overflow-y: scroll`) — the window itself
 * never does. So `window.scrollTo` alone is a no-op and a new route opens at
 * whatever offset the previous one was left at; that's why /get-started used
 * to appear already scrolled halfway down. Reset the scrolling container too.
 */
class ScrollToTop extends React.Component {
    componentDidUpdate(prevProps) {
        const { location } = this.props;
        const prev = prevProps.location;
        if (
            location.pathname !== prev.pathname ||
            location.search !== prev.search
        ) {
            window.scrollTo(0, 0);
            const shell = document.querySelector('.shipment-background');
            if (shell) shell.scrollTop = 0;
        }
    }

    render() {
        return this.props.children
    }
}

export default withRouter(ScrollToTop);
